/* Sugarverse Theme JS – ohne externe Abhängigkeiten */
(function () {
  'use strict';
  var SV = window.SV || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    try {
      return new Intl.NumberFormat(SV.locale || 'de-DE', { style: 'currency', currency: SV.currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + (SV.currency || ''); }
  }
  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  /* ---------- Mobiles Menü & Suche ---------- */
  var menu = $('[data-mobile-menu]');
  $$('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { if (menu) { menu.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); } });
  });
  $$('[data-menu-close]').forEach(function (b) {
    b.addEventListener('click', function () { if (menu) { menu.classList.remove('is-open'); } });
  });
  var searchBar = $('[data-search-bar]');
  $$('[data-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!searchBar) { return; }
      var open = searchBar.hasAttribute('hidden');
      if (open) { searchBar.removeAttribute('hidden'); var f = $('input', searchBar); if (f) { f.focus(); } }
      else { searchBar.setAttribute('hidden', ''); }
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Warenkorb ---------- */
  var drawer = $('[data-cart-drawer]');
  var overlay = $('[data-drawer-overlay]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) { return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.hidden = false; }
    document.body.style.overflow = 'hidden';
    refreshCart();
    drawer.focus();
  }
  function closeDrawer() {
    if (!drawer) { return; }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) { overlay.hidden = true; }
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (overlay) { overlay.addEventListener('click', closeDrawer); }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); if (menu) { menu.classList.remove('is-open'); } }
  });
  $$('[data-cart-link]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (SV.cartType === 'drawer' && drawer) { e.preventDefault(); openDrawer(); }
    });
  });

  function updateCount(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) { el.removeAttribute('data-empty'); } else { el.setAttribute('data-empty', ''); }
    });
  }

  function lineHtml(item) {
    var img = item.featured_image && item.featured_image.url
      ? '<img src="' + esc(item.featured_image.url) + '" alt="' + esc(item.featured_image.alt || item.product_title) + '" width="76" height="76" loading="lazy">' : '';
    var variant = item.variant_title ? '<div class="line__meta">' + esc(item.variant_title) + '</div>' : '';
    var unit = item.unit_price_measurement
      ? '<div class="line__meta">' + money(item.unit_price) + ' / ' + esc(item.unit_price_measurement.reference_value) + '&nbsp;' + esc(item.unit_price_measurement.reference_unit) + '</div>' : '';
    return '<div class="line" data-line="' + esc(item.key) + '">' +
      '<a class="line__img" href="' + esc(item.url) + '">' + img + '</a>' +
      '<div><a class="line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant + unit +
      '<div class="line__row"><div class="qty">' +
      '<button type="button" data-qty="-1" data-key="' + esc(item.key) + '" aria-label="Menge verringern">&minus;</button>' +
      '<input type="number" min="0" value="' + item.quantity + '" data-key="' + esc(item.key) + '" aria-label="Menge">' +
      '<button type="button" data-qty="1" data-key="' + esc(item.key) + '" aria-label="Menge erhöhen">+</button></div>' +
      '<strong>' + money(item.final_line_price) + '</strong></div>' +
      '<button type="button" class="line__remove" data-remove="' + esc(item.key) + '">Entfernen</button></div></div>';
  }

  function renderCart(cart) {
    updateCount(cart);
    var body = $('[data-drawer-body]');
    var foot = $('[data-drawer-foot]');
    if (!body) { return; }
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><p><strong>Dein Warenkorb ist leer.</strong></p><a class="btn" href="/collections/all">Jetzt entdecken</a></div>';
      if (foot) { foot.hidden = true; }
      return;
    }
    var html = '';
    if (SV.freeShipping > 0) {
      var goal = SV.freeShipping * 100;
      var left = goal - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price / goal * 100));
      html += '<div class="ship-bar">' + (left > 0 ? 'Noch ' + money(left) + ' bis zum Gratisversand' : 'Gratisversand erreicht') +
        '<div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
    }
    cart.items.forEach(function (it) { html += lineHtml(it); });
    body.innerHTML = html;
    var total = $('[data-cart-total]');
    if (total) { total.textContent = money(cart.total_price); }
    if (foot) { foot.hidden = false; }
  }

  function refreshCart() {
    return fetch(SV.routes.cartJson, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {
        var body = $('[data-drawer-body]');
        if (body) { body.innerHTML = '<p class="notice notice--error">Der Warenkorb konnte nicht geladen werden. Bitte lade die Seite neu.</p>'; }
      });
  }

  function changeLine(key, qty) {
    return fetch(SV.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.status && cart.description) { alert(cart.description); return refreshCart(); }
      renderCart(cart);
    });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var q = e.target.closest('[data-qty]');
      var r = e.target.closest('[data-remove]');
      if (q) {
        var input = q.parentNode.querySelector('input');
        changeLine(q.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) + parseInt(q.getAttribute('data-qty'), 10)));
      } else if (r) { changeLine(r.getAttribute('data-remove'), 0); }
    });
    drawer.addEventListener('change', function (e) {
      if (e.target.matches('input[data-key]')) { changeLine(e.target.getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0)); }
    });
  }

  /* Warenkorbseite (ohne Drawer): Menge per Formular */
  $$('[data-cart-page] [data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('input');
      input.value = Math.max(0, parseInt(input.value, 10) + parseInt(b.getAttribute('data-qty'), 10));
      input.form.submit();
    });
  });

  /* ---------- In den Warenkorb ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) { return; }
    if (!window.fetch) { return; }
    e.preventDefault();
    var btn = $('[data-add-button]', form);
    var msg = $('[data-form-msg]', form);
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt …'; }
    if (msg) { msg.textContent = ''; }
    fetch(SV.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) { throw new Error(res.description); }
        return refreshCart().then(function () {
          if (SV.cartType === 'drawer' && drawer) { openDrawer(); } else { window.location.href = SV.routes.cart; }
        });
      })
      .catch(function (err) { if (msg) { msg.textContent = err.message || 'Das Produkt konnte nicht hinzugefügt werden.'; } })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* ---------- Mengenfeld Produktseite ---------- */
  $$('.buy .qty').forEach(function (box) {
    var input = $('input', box);
    $$('button', box).forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
      });
    });
  });

  /* ---------- Varianten & Galerie ---------- */
  var pe = $('[data-product-root]');
  if (pe) {
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', pe).textContent); } catch (e) {}
    var form = $('[data-product-form]', pe);
    var idInput = form ? $('input[name="id"]', form) : null;
    var priceBox = $('[data-price]', pe);
    var btn = $('[data-add-button]', pe);

    var gallery = $$('[data-media-id]', pe);
    var mainImg = $('[data-gallery-main]', pe);
    function showMedia(id) {
      var thumb = gallery.filter(function (t) { return t.getAttribute('data-media-id') === String(id); })[0];
      if (!thumb || !mainImg) { return; }
      mainImg.src = thumb.getAttribute('data-src');
      mainImg.alt = thumb.getAttribute('data-alt') || '';
      gallery.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    }
    gallery.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-id')); }); });

    function currentVariant() {
      var chosen = $$('.opt input:checked', pe).map(function (i) { return i.value; });
      if (!chosen.length) { return variants[0]; }
      return variants.filter(function (v) { return v.options.join('|') === chosen.join('|'); })[0];
    }
    function update() {
      var v = currentVariant();
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Nicht verfügbar'; } return; }
      if (idInput) { idInput.value = v.id; }
      if (priceBox) { priceBox.innerHTML = '<div class="price">' + v.price_html + '</div>'; }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft'; }
      if (v.media) { showMedia(v.media); }
      if (window.history && history.replaceState) { history.replaceState({}, '', window.location.pathname + '?variant=' + v.id); }
    }
    $$('.opt input', pe).forEach(function (i) { i.addEventListener('change', update); });
  }

  /* ---------- Karussell-Pfeile ---------- */
  $$('[data-carousel-root]').forEach(function (root) {
    var track = $('[data-carousel]', root);
    $$('[data-dir]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: parseInt(b.getAttribute('data-dir'), 10) * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  });

  /* ---------- Kollektion: Sortierung & Filter ---------- */
  var sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }
  var ff = $('[data-filter-form]');
  if (ff) { ff.addEventListener('change', function () { ff.submit(); }); }

  /* ---------- Produktempfehlungen (Shopify Recommendations API) ---------- */
  $$('[data-recommendations]').forEach(function (box) {
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = $('[data-recommendations]', doc);
      if (src && src.innerHTML.trim().length) { box.innerHTML = src.innerHTML; box.removeAttribute('hidden'); }
    }).catch(function () {});
  });

  /* Zähler beim Laden aktualisieren */
  fetch(SV.routes.cartJson, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(updateCount).catch(function () {});
})();
